import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setLoginPopupOpen } from '../../store/slices/uiSlice'
import { RootState } from '../../store/store'
import Container from '../Container/Container'
import CartIcon from '../Header/CartIcon'
import SearchIcon from '../Header/SearchIcon'
import UserIcon from '../Header/UserIcon'
import LoginPopup from '../LoginPopup/LoginPopup'
import SearchPopup from '../SearchPopup/SearchPopup'
import styles from './HeaderAccount.module.css'

const HeaderAccount = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { isLoginPopupOpen } = useSelector((state: RootState) => state.ui)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isSticky, setIsSticky] = useState(false)
  const [isHiding, setIsHiding] = useState(false)
  const [lastScrollY, setLastScrollY] = useState(0)
  const [isSearchOpen, setIsSearchOpen] = useState(false)

  // Заборона скролу body при відкритому меню
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isMenuOpen])

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY
      if (currentScrollY > 80 && currentScrollY < lastScrollY) {
        setIsSticky(true)
        setIsHiding(false)
      } else if (currentScrollY > lastScrollY) {
        if (isSticky && !isHiding && currentScrollY > 80) {
          setIsHiding(true)
        }
      }
      setLastScrollY(currentScrollY)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [lastScrollY, isSticky, isHiding])

  const handleAnimationEnd = () => {
    if (isHiding) {
      setIsSticky(false)
      setIsHiding(false)
    }
  }

  const handleSearchClick = () => {
    setIsSearchOpen(true)
  }

  const handleCloseSearch = () => {
    setIsSearchOpen(false)
  }

  const handleCloseLoginPopup = () => {
    dispatch(setLoginPopupOpen(false))
  }

  const handleShopClick = () => {
    navigate('/shop')
  }

  // Закриваємо мобільне меню при відкритті попапу логіна
  useEffect(() => {
    if (isLoginPopupOpen && isMenuOpen) {
      setIsMenuOpen(false)
    }
  }, [isLoginPopupOpen, isMenuOpen])

  const isMobile = window.innerWidth < 1024

  return (
    <div className={`${styles.stickyWrap}`} onAnimationEnd={handleAnimationEnd}>
      <Container>
        <header className={styles.header}>
          <div className={styles.leftCol}>
            <button onClick={handleShopClick} className={styles.backToShopButton}>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.8281 15.5V15.5C10.8281 11.6372 7.69119 8.50092 3.82838 8.51128V8.51128"
                  stroke="#BFBFBF"
                  strokeWidth="1.5625"
                />
                <path
                  d="M10.8281 1.5V1.5C10.8281 5.36283 7.69119 8.49908 3.82838 8.48872V8.48872"
                  stroke="#BFBFBF"
                  strokeWidth="1.5625"
                />
              </svg>
              До магазину
            </button>
          </div>
          <div className={styles.actions}>
            {!isMobile && (
              <SearchIcon
                onSearchClick={handleSearchClick}
                onCloseSearch={handleCloseSearch}
                isSearchOpen={isSearchOpen}
                isMobile={isMobile}
              />
            )}

            {!isMenuOpen && <CartIcon />}

            {!isMobile && <UserIcon />}
            {isMenuOpen && <UserIcon />}
          </div>
        </header>
      </Container>
      <SearchPopup isOpen={isSearchOpen} onClose={handleCloseSearch} />
      <LoginPopup isOpen={isLoginPopupOpen} onClose={handleCloseLoginPopup} />
    </div>
  )
}

export default HeaderAccount
